import { BodyPrimary, H2 } from '@liveauctioneers/hammer-ui-core/text';
import { ReactNode } from 'react';

type Props = {
    children?: ReactNode;
    content: string | ReactNode;
    title: string;
};

export const ContentBlock = ({ children, content, title }: Props) => {
    return (
        <div className="flex flex-col gap-sm border border-border-secondary p-sm smMin:p-lg">
            <H2>{title}</H2>
            <BodyPrimary className="[&_a]:text-link-primary [&_a:hover]:text-link-hover">{content}</BodyPrimary>
            {children}
        </div>
    );
};
